import { Box, CircularProgress, IconButton, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React from "react";

interface BlogSearchFieldProps {
  handleSearchSubmit: (e: React.FormEvent<Element>) => void;
  searchQuery: string;
  handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isSearching: boolean;
}

const BlogSearchField: React.FC<BlogSearchFieldProps> = ({
  handleSearchChange,
  searchQuery,
  isSearching,
  handleSearchSubmit,
}) => {
  return (
    <Box
      component="form"
      onSubmit={handleSearchSubmit}
      sx={{ position: "relative", maxWidth: 650 }}
    >
      <TextField
        fullWidth
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder="Search articles..."
        variant="outlined"
        InputProps={{
          sx: {
            borderRadius: 2,
            color: "#1e293b",
          },
          endAdornment: (
            <IconButton
              type="submit"
              disabled={isSearching}
              sx={{
                bgcolor: "primary.main",
                color: "#fff",
                "&:hover": { bgcolor: "primary.dark" },
                ml: 1,
              }}
            >
              {isSearching ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <SearchIcon />
              )}
            </IconButton>
          ),
        }}
      />
    </Box>
  );
};

export default BlogSearchField;
